import { Grid } from "antd";
import { useEffect, useState } from "react";

const { useBreakpoint } = Grid;

const useComponentSize = () => {
  const screen = useBreakpoint();
  const [size, setSize] = useState("default");

  useEffect(() => {
    const { xs, sm, md, lg } = screen;
    setSize(() =>
      xs === true ||
      (xs === false && sm === true && md === true && lg === false)
        ? "default"
        : "large",
    );
  }, [screen]);

  return size;
};

export default useComponentSize;
